"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Grid_1 = require("../Grid");
var ComponentesDeEstilo = __importStar(require("./Modal.styles"));
function Modal(_a) {
  var children = _a.children,
    aoClicarNaSobreposicao = _a.aoClicarNaSobreposicao,
    usarGrid = _a.usarGrid,
    telaCheia = _a.telaCheia,
    aoFechar = _a.aoFechar,
    _b = _a.temBotaoDeFechar,
    temBotaoDeFechar = _b === void 0 ? true : _b,
    sxDoContainerDeConteudo = _a.sxDoContainerDeConteudo,
    sxDoBotaoDeFechar = _a.sxDoBotaoDeFechar,
    _c = _a.ComponenteDeSobreposicao,
    ComponenteDeSobreposicao = _c === void 0 ? ComponentesDeEstilo.Sobreposicao : _c;
  var ComponenteDeEncapsulamento = usarGrid ? Grid_1.Grid : react_1.default.Fragment;
  return react_1.default.createElement(ComponentesDeEstilo.Container, null, react_1.default.createElement(ComponenteDeEncapsulamento, null, react_1.default.createElement(ComponentesDeEstilo.Conteudo, {
    telaCheia: telaCheia,
    sx: sxDoContainerDeConteudo
  }, children, temBotaoDeFechar && react_1.default.createElement(ComponentesDeEstilo.IconeDeFechar, {
    sx: sxDoBotaoDeFechar,
    onClick: aoFechar
  }))), react_1.default.createElement(ComponenteDeSobreposicao, {
    onClick: aoClicarNaSobreposicao !== null && aoClicarNaSobreposicao !== void 0 ? aoClicarNaSobreposicao : aoFechar
  }));
}
exports.Modal = Modal;